if (!customElements.get('ncf-hero')) {
  customElements.define(
    'ncf-hero',
    class NcfHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.index = 0;
        this.timer = null;
        this.userPaused = false;
        this.hovering = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        /* Seconds per slide (section setting), kept between 5 and 15. */
        const speed = Number(this.dataset.speed);
        this.interval = Number.isFinite(speed) ? Math.min(Math.max(speed, 5), 15) * 1000 : 5000;

        this.onDot = this.onDot.bind(this);
        this.onPause = this.onPause.bind(this);
        this.onHold = () => {
          this.hovering = true;
          this.stop();
        };
        this.onRelease = (event) => {
          if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;
          this.hovering = false;
          this.resume();
        };

        /* Theme editor: show the slide being edited. */
        this.onBlockSelect = (event) => {
          const index = this.slides.indexOf(event.target);
          if (index < 0) return;
          this.go(index);
          this.userPaused = true;
          this.stop();
          this.setPauseState();
        };

        this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));
        if (this.pauseButton) this.pauseButton.addEventListener('click', this.onPause);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('mouseenter', this.onHold);
        this.addEventListener('mouseleave', this.onRelease);
        this.addEventListener('focusin', this.onHold);
        this.addEventListener('focusout', this.onRelease);

        if (this.reduced || this.slides.length < 2) {
          this.userPaused = true;
          this.setPauseState();
        } else {
          this.setPauseState();
          this.play();
        }
      }

      disconnectedCallback() {
        this.stop();
        this.dots.forEach((dot) => dot.removeEventListener('click', this.onDot));
        if (this.pauseButton) this.pauseButton.removeEventListener('click', this.onPause);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('mouseenter', this.onHold);
        this.removeEventListener('mouseleave', this.onRelease);
        this.removeEventListener('focusin', this.onHold);
        this.removeEventListener('focusout', this.onRelease);
      }

      /* Choosing a slide stops the rotation, as in the mockup. */
      onDot(event) {
        this.go(Number(event.currentTarget.dataset.dot));
        this.userPaused = true;
        this.stop();
        this.setPauseState();
      }

      onPause() {
        this.userPaused = !this.userPaused;
        this.setPauseState();
        if (this.userPaused) {
          this.stop();
        } else {
          this.play();
        }
      }

      setPauseState() {
        this.classList.toggle('is-paused', this.userPaused);
        if (!this.pauseButton) return;
        const label = this.userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        if (label) this.pauseButton.setAttribute('aria-label', label);
      }

      go(index) {
        this.index = index;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      play() {
        this.stop();
        if (this.userPaused || this.hovering || this.reduced || this.slides.length < 2) return;
        this.timer = window.setInterval(() => {
          this.go((this.index + 1) % this.slides.length);
        }, this.interval);
      }

      resume() {
        if (!this.userPaused) this.play();
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}
